"use client";

import styles from "../../../page.module.scss";

export default function Divider() {
  return (
    <div className={styles.divider}>
      <div></div>
    </div>
  );
}
